import React from 'react';
import { ArrowRight, Radio } from 'lucide-react';
import { EvidenceLabel } from './EvidenceLabel';

// A quiet, editorial highlight for the single premium record temporarily surfaced this week.
// Restrained by design — no banners, no countdowns, no urgency.
export const WeeklyOpenRecord = ({ record, onOpen, className = '' }) => {
  if (!record) return null;
  const opened = record.weekly_opened_at ? new Date(record.weekly_opened_at) : null;
  const surfaced = opened
    ? opened.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
    : null;
  return (
    <div
      onClick={() => onOpen(record.id)}
      className={`weekly-card group cursor-pointer ${className}`}
      data-testid="weekly-open-record"
    >
      <div className="relative z-10">
        <div className="flex items-center gap-2.5 mb-4">
          <span className="weekly-dot" />
          <span className="mono-meta text-[#26B0A8]">This week&rsquo;s open archive record</span>
        </div>
        <p className="mono-meta mb-2 text-[#5b626f]">{record.content_type || 'Field Note'} · Released from the subscriber archive</p>
        <h3 className="font-serif-display text-2xl lg:text-3xl font-light group-hover:text-[#26B0A8] transition-colors">{record.title}</h3>
        <p className="font-sans-tech text-sm text-[#949BAA] mt-3 max-w-2xl leading-relaxed">{record.description}</p>
        {record.evidence_class && <div className="mt-3"><EvidenceLabel evidenceClass={record.evidence_class} testid="weekly-evidence" /></div>}
        <div className="flex items-center justify-between mt-6">
          <span className="mono-meta text-[#5b626f] flex items-center gap-1.5">
            <Radio className="w-3 h-3 opacity-70" /> {surfaced ? `Surfaced ${surfaced}` : 'Temporarily public'} · Temporary archive access
          </span>
          <span className="flex items-center gap-1.5 text-[#26B0A8] text-xs font-mono-tech uppercase tracking-widest">
            Read <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </span>
        </div>
      </div>
    </div>
  );
};

export default WeeklyOpenRecord;
